import {Component, OnInit, Input} from '@angular/core';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {TaskService} from '../../views/management/tasks/task.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UsersShowComponent} from '../../views/setting/users/users-show/users-show.component';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-app-tasks',
    templateUrl: './app-tasks.component.html',
    styleUrls: ['./app-tasks.component.scss'],
    providers: [TaskService]
})
export class AppTasksComponent implements OnInit {
    tasks:any = [];
    status:any = [];
    typeVal:any = [];
    @Input() rowId;
    @Input() refShow;
    modalRef: NgbModalRef;

    constructor(public activeModal: NgbActiveModal,
                public taskService: TaskService,
                public translate: TranslateService,
                private modalService: NgbModal) {
    }

    ngOnInit() {
        this.status[1] = 'Under Distribution';
        this.status[2] = 'Under Post';
        this.status[3] = 'Done Verfiy';
        this.status[4] = 'Task Done';
        this.status[5] = 'Refused';

        this.typeVal[1] = 'Use';
        this.typeVal[2] = 'Team';
        this.typeVal[3] = 'Department';

        this.taskService.list(this.rowId).subscribe(
            tasks => {
                this.tasks = tasks;
            },
            err => {
                console.log(err);
            }
        );
    }

    showUser(user_id:string){
        if(user_id){
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            // const modalRef = this.modalService.open(UsersShowComponent, options);
            // modalRef.componentInstance.refShow = this.refShow;
            // modalRef.componentInstance.scrId = user_id;
        }
    }

    close() {
        this.activeModal.dismiss('done');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/app-tasks/app-tasks.component.ts